import BaseSource, { AVAILABLE_COLLECTION_TYPES } from 'sources/baseSource';
import Customer from 'types/Customer';
import CustomerSourceType from 'sources/sourceTypes/Customer';
import * as mapper from 'sources/mapper/Customer';

class CustomerSource extends BaseSource<Customer, CustomerSourceType, {}> {
  public ObjectURL = 'customers' as AVAILABLE_COLLECTION_TYPES;

  public toSource = mapper.toSource;

  public toType = mapper.toType;
}

const customerSource = new CustomerSource();

export default customerSource;
